(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
